export default __webpack_public_path__ + "img/rank3-6d99d7a9.png";